/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import "./SmallStat.scss";
import { Grid, Tooltip } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/InfoOutlined";

function SmallStat(props) {
  const { item, stats, country, size } = props;

  return (
    <Grid item className="small-stat-card" xs={size}>
      <Grid container className="stat-wrapper" spacing={0}>
        <Grid item xs={12} className="stat-title">
          {item.title}
        </Grid>
        <Grid item xs={12} className="stat-value">
          {stats ? stats[item.name][country] : item[country]}{" "}
        </Grid>
        {item.measurement && (
          <Grid item xs={12} className="stat-measurement">
            {item.measurement}
          </Grid>
        )}
        <Grid item xs={12} className="stat-tooltip">
          <Tooltip arrow  title={item.tooltip}>
            <InfoIcon className="info-icon" />
          </Tooltip>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SmallStat;
